/* */
/**
 * @module actions/Share
 */

import { OVERLAY_SUBTYPES } from '../constants/Overlay';
import { messages, ShareActions } from '../constants/Share';
import { PandoraTypes } from '../constants/SourceTypes';
import ViewActions from '../constants/ViewActions';
import { getInDomain } from '../domains/externalUtils';
import { getAnnotationsById } from '../lib/EntityUtils';
import { isRetired, isUnavailable } from '../lib/RightsUtils';
import Logger from '../tools/Logger';

import { openModal, openModalCoachmark } from './Modal';

const log = Logger.child({ component: 'Share' });

/**
 * Action creator triggered by Share SourceCard item
 *
 * @param {string} pandoraId - pandoraId
 * @param {object} shareParentSource - shareParentSource
 * @returns {object} - Flux standard action
 */

export function openShareModal(pandoraId, shareParentSource = {}) {
  return (dispatch, getState) => {
    let { shareParentSourceId, shareParentSourceType } = shareParentSource;

    if (!pandoraId && !shareParentSourceId) {
      log.error('Intent to share requires either a pandoraId or a shareParentSourceId');
      return;
    }

    const isThumbprintRadio =
      shareParentSourceId &&
      getInDomain('playback.utils.isThumbprintStationId', false)(getState(), shareParentSourceId) &&
      !pandoraId.startsWith(PandoraTypes.SONG);
    const isHybridStation =
      shareParentSourceId &&
      getInDomain('playback.utils.getStationIsAdvertiser', false)(getState(), shareParentSourceId);

    let childId =
      (pandoraId && pandoraId.endsWith(shareParentSourceId)) || isThumbprintRadio || isHybridStation
        ? null
        : pandoraId;

    const annotations = getAnnotationsById(getState(), pandoraId);
    const shareType = annotations && annotations.get('type');

    switch (shareType) {
      case PandoraTypes.EPISODE:
        childId = pandoraId;
        shareParentSourceId = annotations && annotations.get('podcastId');
        shareParentSourceType = PandoraTypes.PODCAST;
        break;
      case PandoraTypes.PODCAST:
        shareParentSourceId = pandoraId;
        shareParentSourceType = PandoraTypes.PODCAST;
        break;
    }

    if (isUnavailable(annotations) || isRetired(annotations)) {
      let message;
      switch (shareType) {
        case PandoraTypes.ALBUM:
          message = messages.cannotShareAlbum;
          break;
        case PandoraTypes.SONG:
          message = messages.cannotShareSong;
          break;
        case PandoraTypes.PLAYLIST:
          message = messages.cannotSharePlaylist;
          break;
        case PandoraTypes.EPISODE:
          message = messages.cannotSharePodcast;
          break;
        case PandoraTypes.PODCAST:
          message = messages.cannotSharePodcast;
          break;
        default:
          message = messages.cannotShareDefault;
          break;
      }
      return dispatch(openModalCoachmark(message));
    }

    return dispatch(
      openModal({
        modalType: OVERLAY_SUBTYPES.MODALSHARE,
        childId,
        parentSourceId: shareParentSourceId,
        parentSourceType: shareParentSourceType,
      }),
    );
  };
}

export function showShareCoachmark(body) {
  return {
    type: ShareActions.SHOW_SHARE_COACHMARK,
    body,
  };
}

export function clickedShareOption({ shareMethod, twitter, twitterHandle, facebook, sourceId }) {
  return {
    type: ShareActions.SHARE_OPTION_CLICKED,
    shareData: {
      shareMethod,
      twitter,
      twitterHandle,
      facebook,
      sourceId,
    },
  };
}

export function showedShareModal({ parentSource, sourceId }) {
  return {
    type: ViewActions.SHOWED_SHARE_MODAL,
    shareData: {
      sourceId,
      parentSource,
    },
  };
}
